<page-title text="Our Security Protocols for Users Protection | BitOasis" i18n-text="@@pageTitle.security"></page-title>
<page-meta
    description="Learn why BitOasis is considered the region's most trusted crypto platform and how you can help protect your account."
    i18n-description="@@pageMeta.description.security">
</page-meta>
<site-layout class="white full" [hideHeader]="!!(isMobileWebView$ | async)">
  <section class="header">
    <div class="animation-title">
      <span i18n="@@front.security.start.most">Most</span>
      <p class="text-animation" #animationText></p>
      <span></span>
    </div>
    <p class="sub-text mt-5" i18n="@@front.security.start.text">We employ cutting-edge security solutions in our applications and infrastructure to actively protect your funds and data.</p>
  </section>
  <section class="text-center">
    <div class="p-5"></div>
    <h4 class="text-bold mt-2 mb-5" i18n="@@front.security.start.subtitle">Get started today with the region's most trusted crypto platform.</h4>
    <a [routerLink]="['/register']" class="btn btn-primary btn-wide" i18n="@@front.security.start.btn">Start Trading</a>
    <p class="text-gray mt-3">
      <span i18n="@@front.security.start.info">We care about protecting your data. Here’s our </span>
      <a [routerLink]="['/page/privacy-policy']" class="btn btn-link p-0" i18n="@@front.security.start.link">Privacy Policy.</a>
    </p>
    <div class="p-5 p-md-0"></div>
  </section>
  <section class="panel row d-none d-md-flex align-items-center justify-content-center">
    <div class="col col-6">
      <h2 class="title" i18n="@@front.security.fingerprint.title">We drive defense-in-depth security strategy across our platforms.</h2>
      <p i18n="@@front.security.fingerprint.content">Defense in Depth (DiD) is a multi-layered approach to cybersecurity in which a series of defensive mechanisms are layered in order to protect information. If one mechanism fails, another steps up immediately to stop an attack.</p>
    </div>
    <div class="col col-4 animation-block">
      <ng-lottie [options]="{ path: 'assets/lottie/fingerprint.json', loop: false }"></ng-lottie>
    </div>
  </section>
  <section class="group">
    <div class="row row-styled row row-styled-styled">
      <div class="col col-md-3 animation-block">
        <ng-lottie [options]="{ path: 'assets/lottie/shield.json', loop: false }"></ng-lottie>
      </div>
      <div class="col-10 col-md-7">
        <h3 class="title" i18n="@@front.security.info.security.title">Secure Software</h3>
        <p i18n="@@front.security.info.security.content">To become the region's most trusted crypto exchange, we've operated with a security-first mindset from day one. We have several measures in place to keep your crypto and fiat funds safe on BitOasis. Our Tech team along with our cybersecurity team is always planning and implementing secure software development practices and continuously improving software development. This has helped us build a platform on a solid foundation that adheres to industry-grade data protection checks to safeguard your personal information.</p>
      </div>
    </div>

    <div class="row row-styled">
      <div class="col col-md-3 order-md-1 animation-block">
        <ng-lottie [options]="{ path: 'assets/lottie/search.json', loop: false }"></ng-lottie>
      </div>
      <div class="col-10 col-md-7">
        <h3 class="title" i18n="@@front.security.info.multi.title">Multi-Factor Authentication</h3>
        <p i18n="@@front.security.info.multi.content">Experience higher security for the highest convenience. The BitOasis platform is designed to protect your transactions with advanced mechanisms like the Multi-Factor Authentication (MFA) feature– a security technology that requires multiple methods of authenticating your login. A multilayered approach such as MFA safeguards your data through a broad range of security measures like biometrics, email, SMS, and Time-based One-Time Password (TOTP).</p>
      </div>
    </div>

    <div class="row row-styled">
      <div class="col col-md-3 animation-block">
        <ng-lottie [options]="{ path: 'assets/lottie/storage.json', loop: false }"></ng-lottie>
      </div>
      <div class="col-10 col-md-7">
        <h3 class="title" i18n="@@front.security.info.storage.title">Cold Storage</h3>
        <p i18n="@@front.security.info.storage.content">With security at its core, BitOasis safely stores and transfers crypto without jeopardizing the efficiency of your trading operations. A majority of users’ cryptocurrencies are held offline in cold storage, a solution that protects users' funds from malicious attacks. Allowing you to invest in crypto assets confidently; knowing that your Bitcoin, Ethereum, and other assets are protected by BitOasis' industry-leading security and protection.</p>
      </div>
    </div>

    <div class="row row-styled">
      <div class="col col-md-3 order-md-1 animation-block">
        <ng-lottie [options]="{ path: 'assets/lottie/verification.json', loop: false }"></ng-lottie>
      </div>
      <div class="col-10 col-md-7">
        <h3 class="title" i18n="@@front.security.info.compliance.title">Legal Compliance</h3>
        <p i18n="@@front.security.info.compliance.content">BitOasis is the UAE’s first virtual asset service provider to be linked with the GoAML platform launched by the UAE’s Financial Intelligence Unit. We’re also proud to work the National Committee for Combating Money Laundering and the Financing of Terrorism and Illegal Organisations (NAMLCFTC) and the UAE Financial Intelligence Unit (UAE FIU). This is a big step towards building a robust tech infrastructure that will help ensure financial security for the UAE and its FinTech startups.</p>
      </div>
    </div>

    <div class="row row-styled">
      <div class="col col-md-3 animation-block">
        <ng-lottie [options]="{ path: 'assets/lottie/bulb.json', loop: false }"></ng-lottie>
      </div>
      <div class="col-10 col-md-7">
        <h3 class="title" i18n="@@front.security.info.training.title">Training and Awareness</h3>
        <p i18n="@@front.security.info.training.content">We invest heavily in ongoing security and privacy awareness training for all of our teams, while our dedicated team monitors transactions for fraudulent activities. Also, we support and participate in different activities aimed to increase awareness around cryptocurrencies in the region, in cooperation with high-profile partners.</p>
      </div>
    </div>

    <div class="row row-styled">
      <div class="col col-md-3 order-md-1 animation-block">
        <ng-lottie [options]="{ path: 'assets/lottie/chat.json', loop: false }"></ng-lottie>
      </div>
      <div class="col-10 col-md-7">
        <h3 class="title" i18n="@@front.security.info.help.title">Help us keep our community safe</h3>
        <p>
          <span i18n="@@front.security.info.help.content">We want to ensure that you make the most of your BitOasis experience. We constantly monitor any security threats in our network and beyond. Even you can help us build a safe and open financial system by reporting any suspicious activity. Our team is ready to help should you encounter any suspicious activities, and we recommend you reach out to our </span>
          <a [routerLink]="['/support']" i18n="@@front.security.info.help.link">support team</a>
        </p>
      </div>
    </div>
  </section>

  <section class="group text-center mt-5 pb-5">
    <h2 class="title mt-2 mb-5" i18n="@@front.security.answers.title">We've got the answers for your questions</h2>
    <accordion-component>
      <accordion-item
        title="How do I protect my BitOasis account?"
        i18n-title="@@front.security.answers.item0.title"
      >
        <p i18n="@@front.security.answers.item0.info">Ensure that you use the official BitOasis mobile app/website to access your account. Our mobile app is published on Google Play and Apple App Store. Using the BitOasis mobile app, secure your mobile device using security measures. You may refer to the tips given <a href="https://blog.bitoasis.net/protect-yourself-from-phishing-scams">here</a>. Set a strong password, and do not use the same for any other accounts like social media, bank, etc. Once you are done, remember to log out of your session. BitOasis team will never ask for any passwords, TOTP, or credentials that can be used to access your account. So never share such details with anyone claiming to be representing BitOasis.</p>
      </accordion-item>
      <accordion-item
        title="How do I protect my funds from phishing scams?"
        i18n-title="@@front.security.answers.item1.title"
      >
        <p i18n="@@front.security.answers.item1.info">Check and re-check before clicking on any URLs/links received over emails, SMS, or any other messaging tools. Never download any files or mobile apps from unknown sources.Please refer to this quick <a href="https://blog.bitoasis.net/protect-yourself-from-phishing-scams">guide</a> for all details & tips.</p>
      </accordion-item>
      <accordion-item
        title="What are the best ways to protect my mobile device?"
        i18n-title="@@front.security.answers.item2.title"
      >
        <p i18n="@@front.security.answers.item2.info"><a href="https://blog.bitoasis.net/safely-trade-crypto-mobile/">Here</a> are some easy tips to protect your mobile device.</p>
      </accordion-item>
      <accordion-item
        title="If I encounter any potential security issue, whom should I reach out to?"
        i18n-title="@@front.security.answers.item3.title"
      >
        <p i18n="@@front.security.answers.item3.info">If you spot any anomaly or a potential security issue, please immediately reach out to the BitOasis Customer Support team.</p>
      </accordion-item>
    </accordion-component>
  </section>
</site-layout>
<site-footer></site-footer>
